import { ProductManualLanguageDetails } from "domain/language";

const LANGUAGES: ProductManualLanguageDetails[] = [
    { code: "en_US", title: "English", shortCode: "en" },
    { code: "fr_FR", title: "Français", shortCode: "fr" },
    { code: "de_DE", title: "Deutsch", shortCode: "de" },
    { code: "ja_JP", title: "日本語", shortCode: "ja" },
    { code: "es_ES", title: "Español", shortCode: "es" },
    { code: "pt_BR", title: "Português", shortCode: "pt" },
    { code: "zh_CN", title: "中国人", shortCode: "zh" },
    { code: "zh_TW", title: "中國人", shortCode: "zh" },
    { code: "zh_CH", title: "中國人", shortCode: "zh" },
    { code: "ru_RU", title: "русский", shortCode: "ru" },
    { code: "it_IT", title: "Italiano", shortCode: "it" },
    { code: "sk_SK", title: "slovenský", shortCode: "sk" },
    { code: "ko_KR", title: "한국인", shortCode: "ko" },
];

export function getProductManualLanguage(code: string): ProductManualLanguageDetails {
    const DEFAULT_LANGUAGE = { code: code, title: code, shortCode: code };
    return LANGUAGES.find((language) => language.code === code) || DEFAULT_LANGUAGE;
}

export function getLanguageTitleByCode(langCode: string): string {
    const language = LANGUAGES.find((lang) => lang.shortCode === langCode);
    return language?.title || langCode;
}
